<style>
</style>

<template>
  <div>
  </div>
</template>

<script>
import { Icon, Style } from 'ol/style'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import Vector from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Select from 'ol/interaction/Select'
import {click} from 'ol/events/condition'
export default {
  props: ['Mineinfo'],
  data()
  {
    return {
      test: '',
      pointAry: []
    }
  },
  watch: {
    'Mineinfo': function(n, o)
    {
      if (n === true)
        this.getMine()
      else
      {
        this.pointAry.forEach(e =>
        {
          window.map.removeLayer(e)
        })
      }
    }
  },
  methods: {
    /**
     * 三维矿山
     */
    getMine()
    {
      let self = this
      //矢量标注图层
      let paras = {cmd: 'query', _major: 11, _minor: 75, _exp: 'id > 0'}
      window.post.getPost(paras).then((ret) =>
      {
        ret.forEach(data =>
        {
          let rome = new Feature({
            geometry: new Point([data.x, data.y]), //几何信息
            name: data.name,
            url: data.url
          })
          let vector = new Vector()
          vector.addFeature(rome)
          this.wfsVectorLayer = new VectorLayer({
            source: vector,
            style: new Style({
              image: new Icon({
                color: '#1296db',
                crossOrigin: 'anonymous',
                src: 'static/index/didian.png'
              })
            })
          })
          this.pointAry.push(this.wfsVectorLayer)
          window.map.addLayer(this.wfsVectorLayer)
        })
        let selectClick = new Select({
          condition: click
        })
        window.map.addInteraction(selectClick)
        selectClick.on('select', function(e)
        {
          this.name = e.target.getFeatures().array_[0].values_.name
          this.url = e.target.getFeatures().array_[0].values_.url
          cx.http.loadText(this.url).then(ret =>
          {
            this.mineUrl = ret[0].geoidx
            let obj = {
              route: this.url,
              name: this.name,
              url: this.mineUrl,
              bool: true
            }
            self.$store.commit('setMinedata', obj)
          })
        })
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/MineShow.vue